import { onMounted, onUnmounted } from "vue";

// D-CD-33 / REQ-CD-P1-CON-06 — interval polling, suspended while the
// document is hidden and resumed with an immediate fetch. Cleared on
// unmount. The caller is responsible for its own initial fetch on mount;
// this composable owns only the recurring interval.
export function usePolling(fn: () => void | Promise<void>, intervalMs: number): void {
  let timer: ReturnType<typeof setInterval> | null = null;

  function start(): void {
    if (timer !== null) return;
    timer = setInterval(() => {
      void fn();
    }, intervalMs);
  }

  function stop(): void {
    if (timer === null) return;
    clearInterval(timer);
    timer = null;
  }

  function handleVisibilityChange(): void {
    if (document.visibilityState === "visible") {
      void fn();
      start();
    } else {
      stop();
    }
  }

  onMounted(() => {
    document.addEventListener("visibilitychange", handleVisibilityChange);
    if (document.visibilityState === "visible") {
      start();
    }
  });

  onUnmounted(() => {
    document.removeEventListener("visibilitychange", handleVisibilityChange);
    stop();
  });
}
